import type {
	CheckoutResponse,
	CreateReservationResponse,
	InputControlType,
	InputValue,
	Money,
	Order,
	RegistrationStatus,
	RsvpStatusOptions,
	TicketDefinition,
	TicketReservation,
} from '@wix/ambassador-wix-events-web/types'

export interface SelectedTicket {
	ticketId: string
	quantity: number
}

export type SelectedTickets = Array<SelectedTicket>

export interface EditorInput {
	name: string
	value: string
}

export type EditorInputs = Array<EditorInput>

export interface EditorControl {
	array: boolean
	label: string
	options: Array<string>
	maxLength: number
	additionalLabels: Array<{ name: string; label: string }>
	required: boolean
	controlType: InputControlType
	name: string
	_id: string
}

export enum RsvpStatus {
	YES = 'YES',
	NO = 'NO',
	WAITING = 'WAITING',
}

export interface RegistrationForm {
	rsvpStatus?: RsvpStatus
	[key: string]: any
}

export interface LegacyFormData {
	rsvpStatusOptions: RsvpStatusOptions
	rsvpFormInputs: Array<EditorControl>
	registrationStatus: RegistrationStatus
	isTicketed: boolean
}

export interface FormData {
	formInputs: Array<EditorControl>
	rsvpStatusOptions?: RsvpStatusOptions
	registrationStatus: RegistrationStatus
	isTicketed: boolean
}

export interface ValidationResponse {
	valid: boolean
}

export interface CheckInCorvid {
	created?: Date | null
	checkInCanceledDate?: Date | null
	checkedInBy?: string | null
	checkInCanceledBy?: string | null
	checkedInByStaffMember?: string | null
	checkInCanceledByStaffMember?: string | null
}

export interface GuestCorvid {
	index?: number
	fullName?: string
	checkIn?: CheckInCorvid
	id?: number
}

export interface RsvpCorvid {
	id?: string
	eventId?: string
	contactId?: string
	memberId?: string
	firstName?: string
	lastName?: string
	email?: string
	status?: RsvpStatus
	totalGuests?: number
	guests?: GuestCorvid[]
	anonymized?: boolean
	language?: string | null
	locale?: string | null
	marketingConsent?: boolean | null
	createdDate: Date
	updatedDate: Date
	rsvpForm: FormResponseCorvid
}

export interface FormResponseCorvid {
	inputValues: Array<Omit<InputValue, 'number'>>
}

export interface TicketDefinitionCorvid extends Omit<TicketDefinition, 'id'> {
	_id: string
}

export interface TicketReservationCorvid extends Omit<TicketReservation, 'ticket'> {
	ticket: TicketDefinitionCorvid
}

export interface ReserveTicketsResponseCorvid extends Omit<CreateReservationResponse, 'expire' | 'reservations'> {
	expirationTime: Date
	reservations: Array<TicketReservationCorvid>
}

export interface OrderCorvid extends Omit<
	Order,
	'created' | 'checkoutForm' | 'snapshotId' | 'method' | 'totalPrice' | 'ticketsQuantity'
> {
	createdDate: Date
	checkoutForm: FormResponseCorvid
	paymentId: string
	paymentMethod: string
	price: Money
	ticketQuantity: number
}

export interface CheckoutResponseCorvid extends Omit<CheckoutResponse, 'expires' | 'order'> {
	expirationTime: Date
	order: OrderCorvid
}

export interface UpdateOrderResponseCorvid {
	order: OrderCorvid
}
